import styled from 'styled-components'
import { Flex } from 'ui/acro'

const SubStyleChip = styled(Flex)`
    justify-content: space-between;
    align-items: center;
    padding: 4px;
    border: 1px solid #A3A3A3;
    background: #FFF;
    color: #000;
    text-align: center;
    font-family: "Proxima-Nova";
    font-size: 12px;
    font-weight: 400;
    line-height: 14px; /* 116.667% */
    letter-spacing: 0.84px;
    text-transform: uppercase;
)`
export default SubStyleChip
